module.exports = __webpack_public_path__ + "static/media/230-singapore.f9910569.svg";